"use client";

import Script from "next/script";
import { useEffect } from "react";

const YM_COUNTER_ID = "105470744";

type YmWindow = Window & { ym?: (...args: unknown[]) => void };

export function YandexMetrika() {
  // Тот же делегированный перехват CTA, что и в GA, но с отправкой reachGoal
  // в Метрику: клики по [data-cta-location] видны в обеих системах.
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target as Element | null;
      const element = target?.closest?.("[data-cta-location]");
      if (!element) return;
      const ym = (window as YmWindow).ym;
      if (typeof ym !== "function") return;
      ym(YM_COUNTER_ID, "reachGoal", "cta_click", {
        cta_location: element.getAttribute("data-cta-location"),
      });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <>
      <Script id="yandex-metrika" strategy="lazyOnload">
        {`
          (function(m,e,t,r,i,k,a){
            m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
          })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${YM_COUNTER_ID}', 'ym');

          ym(${YM_COUNTER_ID}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});
        `}
      </Script>
    </>
  );
}
